export default "__VITE_ASSET__c01931d5__"